import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * Archived Trips — trips that have been filed away (trip archiving, 2026-07-29).
 *
 * A trip that has actually run cannot be deleted; archiving is what takes it
 * off the working lists instead. Everything recorded on it is kept, and it can
 * be restored from its detail page.
 *
 * The `tripArchived` filter INVERTS the backend's default: every other view
 * excludes archived trips, and this one shows only them.
 */
export const archivedTripsList: ListBuilderList = {
	id: 'archived-trips',
	name: 'Archived',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		tripArchived: {
			// Hidden for the same reason as the Open tab: the chip rendered as
			// "Archived Archived" and duplicated the tab name.
			hidden: true,
			defaultValue: [{ id: 'archived', label: 'Archived' }],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-desc',
	sortOrder: 3,
};
